import moment from "moment";

/**
 * API datetimes are stored in UTC but often serialized without a timezone suffix.
 * Treat timezone-less values as UTC, then convert to local time for display.
 */
export const parseApiUtcDate = (value) => {
  if (value == null || value === "") {
    return moment();
  }

  const str = String(value).trim();
  if (!str) {
    return moment();
  }

  const hasTimezone = str.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(str);
  if (hasTimezone) {
    return moment(str).local();
  }

  return moment.utc(str).local();
};

export const formatRelativeTime = (value) => parseApiUtcDate(value).fromNow();
